// Vastu tab tour steps
import type { TourStep } from './types';

export const VASTU_TOUR: TourStep[] = [
  {
    target: 'body',
    content: 'Vastu integrates your astrological chart with directional energies for home and workspace optimization.',
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="vastu-chart"]',
    content: 'This compass shows which planets govern each cardinal direction in your chart.',
    placement: 'right',
  },
  {
    target: '[data-tour="vastu-life-areas"]',
    content: 'See recommended directions for each life area based on your planetary placements.',
    placement: 'left',
  },
  {
    target: '[data-tour="vastu-room-planner"]',
    content: 'Get personalized room placement recommendations for your home or office based on Vastu + astrology.',
    placement: 'bottom',
  },
];
